import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { Dialog } from '@headlessui/react';
import { useSpring, animated, config } from '@react-spring/web';
import { useCallback, useEffect, useRef } from 'react';
import { useGesture } from '@use-gesture/react';
import { ModalOverlay } from '..';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AnimatedModal = animated(Dialog);
export function ModalMobile(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      children = _ref.children,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      haltGestures = _ref.haltGestures;
  var height = 646;

  var _useSpring = useSpring(function () {
    return {
      y: height
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      y = _useSpring2[0].y,
      api = _useSpring2[1];

  var wHeight = useRef(height / 2);
  useEffect(function () {
    wHeight.current = window.innerHeight;
  }, []);
  var bindGesture = useGesture({
    onDrag: function onDrag(_ref2) {
      var last = _ref2.last,
          _ref2$velocity = _slicedToArray(_ref2.velocity, 2),
          vy = _ref2$velocity[1],
          _ref2$direction = _slicedToArray(_ref2.direction, 2),
          dy = _ref2$direction[1],
          _ref2$movement = _slicedToArray(_ref2.movement, 2),
          my = _ref2$movement[1],
          canceled = _ref2.canceled;

      // when the user releases the sheet, we check whether it passed
      // the threshold for it to close, or if we reset it to its open positino
      if (last) {
        my > height * 0.5 || vy > 0.5 && dy > 0 ? closeModal(vy) : openModal({
          canceled: canceled
        });
      } // when the user keeps dragging, we just move the sheet according to
      // the cursor position
      else api.start({
        y: my,
        immediate: true
      });
    },
    onScroll: function onScroll(_ref3) {
      var _ref3$delta = _slicedToArray(_ref3.delta, 2),
          dy = _ref3$delta[1];

      api.start({
        y: Math.max(-height + wHeight.current, Math.min(y.get() - dy * 3, 0)),
        config: config.stiff,
        immediate: true
      });
    }
  }, {
    drag: {
      from: function from() {
        return [0, y.get()];
      },
      filterTaps: true,
      bounds: {
        top: 0
      },
      rubberband: true,
      delay: 300
    },
    scroll: {
      bounds: {
        top: wHeight.current,
        bottom: 0
      }
    }
  });
  var openModal = useCallback(function (_ref4) {
    var canceled = _ref4.canceled;
    // when cancel is true, it means that the user passed the upwards threshold
    // so we change the spring config to create a nice wobbly effect
    api.start({
      y: 0,
      immediate: false,
      config: canceled ? config.wobbly : config.stiff
    });
  }, [api]);
  var closeModal = useCallback(function () {
    var velocity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    api.start({
      y: height,
      immediate: false,
      config: _objectSpread(_objectSpread({}, config.stiff), {}, {
        velocity: velocity
      })
    });
  }, [api]);
  useEffect(function () {
    if (isOpen) {
      openModal({
        canceled: false
      });
    }
  }, [isOpen, openModal]);
  var display = y.to(function (py) {
    return py < height ? 'flex' : 'none';
  });
  return isOpen ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ModalOverlay, {
      show: isOpen,
      onClick: onClose
    }), /*#__PURE__*/_jsx(StyledModal, _objectSpread(_objectSpread({
      variant: variant,
      open: isOpen,
      onClose: onClose
    }, haltGestures ? {} : bindGesture()), {}, {
      style: {
        display: display,
        y: y
      },
      children: /*#__PURE__*/_jsx(StyledModalCard, {
        className: "modal-card",
        children: children
      })
    }))]
  }) : null;
}

var StyledModal = /*#__PURE__*/_styled(AnimatedModal).withConfig({
  displayName: "modal-mobile__StyledModal",
  componentId: "sc-n2hg1h-0"
})(["", ";", " > div:nth-child(2){", " > div:nth-child(2){", "}}"], {
  "position": "fixed",
  "top": "10vh",
  "zIndex": "160",
  "display": "flex",
  "height": "90vh",
  "width": "100vw",
  "maxWidth": "none",
  "touchAction": "none",
  "flexDirection": "column",
  "alignItems": "center",
  "@media (min-width: 640px)": {
    "bottom": "0px"
  },
  "@media (min-width: 25.75rem)": {
    "bottom": "0px"
  }
}, function (_ref5) {
  var variant = _ref5.variant;
  return {
    primary: {},
    secondary: [{
      "overflowY": "auto"
    }],
    tertiary: {}
  }[variant];
}, {
  "@media (min-width: 768px)": {
    "height": "100%",
    "padding": "0px"
  }
}, {
  "borderRadius": "0px",
  "backgroundImage": "none",
  "--tw-shadow": "0 0 #0000",
  "--tw-shadow-colored": "0 0 #0000",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});

var StyledModalCard = /*#__PURE__*/_styled.div.withConfig({
  displayName: "modal-mobile__StyledModalCard",
  componentId: "sc-n2hg1h-1"
})(["", ""], {
  "display": "flex",
  "height": "100%",
  "width": "90vw",
  "maxWidth": "26rem",
  "--tw-pan-y": "pan-y",
  "touchAction": "var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom)",
  "flexDirection": "column",
  "alignItems": "center",
  "overflow": "scroll",
  "borderTopLeftRadius": "1.5rem",
  "borderTopRightRadius": "1.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "paddingBottom": "48px",
  "--tw-shadow": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  "--tw-shadow-colored": "0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});